import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Plus = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M12 3.95801C12.4142 3.95801 12.75 4.29379 12.75 4.70801V10.958H19C19.4142 10.958 19.75 11.2938 19.75 11.708C19.75 12.1222 19.4142 12.458 19 12.458H12.75V18.708C12.75 19.1222 12.4142 19.458 12 19.458C11.5858 19.458 11.25 19.1222 11.25 18.708V12.458H5C4.58579 12.458 4.25 12.1222 4.25 11.708C4.25 11.2938 4.58579 10.958 5 10.958H11.25V4.70801C11.25 4.29379 11.5858 3.95801 12 3.95801Z'
        fill='currentColor'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.25 19C11.25 19.4142 11.5858 19.75 12 19.75C12.4142 19.75 12.75 19.4142 12.75 19V12.75H19C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H15.875H12.75V5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5V11.25H5C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75H11.25V19Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
